import React from "react";

const Planstarifs = () => {
  return (
    <main className="pb-[2400px] md:pb-[1700px] lg:pb-[800px]">
      <section className="relative py-24 text-white bg-gradient-to-r from-blue-primary to-primary-green">
        <div className="container px-6 mx-auto text-center">
          <h1 className="text-4xl font-bold">Plans et tarifs</h1>
        </div>

        <div className="absolute left-0 right-0 ">
          <div className="w-11/12 mx-auto bg-white shadow-lg rounded-tl-3xl -bottom-3 rounded-tr-3xl">
            {/* Cards Section */}
            <div className="px-6 pt-16 pb-8 mt-8 bg-white shadow-lg rounded-tl-3xl rounded-tr-3xl">
              <div className="container grid grid-cols-1 gap-3 mx-auto md:grid-cols-2 lg:grid-cols-3">
                {/* Card 1 */}
                <div className="p-6 text-center transition-shadow border-4 shadow-lg border-blue-primary rounded-xl hover:shadow-xl">
                  <h2 className="text-2xl font-bold text-gray-800">FREEMUIM</h2>
                  <div className="my-4 border-t"></div>{" "}
                  {/* Ligne séparatrice */}
                  <div className="flex justify-between">
                    <p className="text-gray-600">Annual subscription</p>
                    <p className="text-gray-800 font-bold">$0</p>
                  </div>
                  <div className="my-4 border-t"></div>{" "}
                  {/* Ligne séparatrice */}
                  <div className="flex justify-between">
                    <p className="text-gray-600">Delivery Services</p>
                    <img
                      src="/assets/images/vecteurs/close.svg"
                      alt="icon"
                      className="w-10"
                    />
                  </div>
                  <div className="my-4 border-t"></div>{" "}
                  {/* Ligne séparatrice */}
                  <div className="flex justify-between">
                    <p className="text-gray-600">Nearby Services</p>
                    <img
                      src="/assets/images/pharmacy/succesIcon.svg"
                      alt="icon"
                      className="w-10"
                    />
                  </div>
                  <div className="my-4 border-t"></div>{" "}
                  {/* Ligne séparatrice */}
                  <div className="flex justify-between">
                    <p className="text-gray-600">Call emergencies</p>
                    <img
                      src="/assets/images/pharmacy/succesIcon.svg"
                      alt="icon"
                      className="w-10"
                    />
                  </div>
                  <div className="my-4 border-t"></div>{" "}
                  {/* Ligne séparatrice */}
                  <div className="flex justify-between">
                    <p className="text-gray-600">Order medications</p>
                    <img
                      src="/assets/images/pharmacy/succesIcon.svg"
                      alt="icon"
                      className="w-10"
                    />
                  </div>
                  <div className="my-4 border-t"></div>{" "}
                  {/* Ligne séparatrice */}
                  <div className="flex justify-between">
                    <p className="text-gray-600">Services fees</p>
                    <img
                      src="/assets/images/vecteurs/close.svg"
                      alt="icon"
                      className="w-10"
                    />
                  </div>
                  <div className="my-4 border-t"></div>{" "}
                  {/* Ligne séparatrice */}
                  <div className="flex justify-between">
                    <p className="text-gray-600">Record Keeping</p>
                    <img
                      src="/assets/images/vecteurs/close.svg"
                      alt="icon"
                      className="w-10"
                    />
                  </div>
                  <div className="my-4 border-t"></div>{" "}
                  {/* Ligne séparatrice */}
                  <div className="flex justify-between">
                    <p className="text-gray-600">Data exchange</p>
                    <img
                      src="/assets/images/vecteurs/close.svg"
                      alt="icon"
                      className="w-10"
                    />
                  </div>
                  <div className="my-4 border-t"></div>{" "}
                  {/* Ligne séparatrice */}
                  <div className="flex justify-between">
                    <p className="text-gray-600">scheduling appointments</p>
                    <img
                      src="/assets/images/vecteurs/close.svg"
                      alt="icon"
                      className="w-10"
                    />
                  </div>
                </div>

                {/* Card 2 */}
                <div className="p-6 text-center transition-shadow border-4 shadow-lg border-primary-green rounded-xl hover:shadow-xl">
                  <h2 className="text-2xl font-bold text-gray-800">STANDARD</h2>
                  <div className="my-4 border-t"></div>{" "}
                  {/* Ligne séparatrice */}
                  <div className="flex justify-between">
                    <p className="text-gray-600">Annual subscription</p>
                    <p className="text-gray-800 font-bold">$05</p>
                  </div>
                  <div className="my-4 border-t"></div>{" "}
                  {/* Ligne séparatrice */}
                  <div className="flex justify-between">
                    <p className="text-gray-600">Delivery Services</p>
                    <img
                      src="/assets/images/vecteurs/close.svg"
                      alt="icon"
                      className="w-10"
                    />
                  </div>
                  <div className="my-4 border-t"></div>{" "}
                  {/* Ligne séparatrice */}
                  <div className="flex justify-between">
                    <p className="text-gray-600">Nearby Services</p>
                    <img
                      src="/assets/images/pharmacy/succesIcon.svg"
                      alt="icon"
                      className="w-10"
                    />
                  </div>
                  <div className="my-4 border-t"></div>{" "}
                  {/* Ligne séparatrice */}
                  <div className="flex justify-between">
                    <p className="text-gray-600">Call emergencies</p>
                    <img
                      src="/assets/images/pharmacy/succesIcon.svg"
                      alt="icon"
                      className="w-10"
                    />
                  </div>
                  <div className="my-4 border-t"></div>{" "}
                  {/* Ligne séparatrice */}
                  <div className="flex justify-between">
                    <p className="text-gray-600">Order medications</p>
                    <img
                      src="/assets/images/pharmacy/succesIcon.svg"
                      alt="icon"
                      className="w-10"
                    />
                  </div>
                  <div className="my-4 border-t"></div>{" "}
                  {/* Ligne séparatrice */}
                  <div className="flex justify-between">
                    <p className="text-gray-600">Services fees</p>
                    <img
                      src="/assets/images/pharmacy/succesIcon.svg"
                      alt="icon"
                      className="w-10"
                    />
                  </div>
                  <div className="my-4 border-t"></div>{" "}
                  {/* Ligne séparatrice */}
                  <div className="flex justify-between">
                    <p className="text-gray-600">Record Keeping</p>
                    <img
                      src="/assets/images/pharmacy/succesIcon.svg"
                      alt="icon"
                      className="w-10"
                    />
                  </div>
                  <div className="my-4 border-t"></div>{" "}
                  {/* Ligne séparatrice */}
                  <div className="flex justify-between">
                    <p className="text-gray-600">Data exchange</p>
                    <img
                      src="/assets/images/vecteurs/close.svg"
                      alt="icon"
                      className="w-10"
                    />
                  </div>
                  <div className="my-4 border-t"></div>{" "}
                  {/* Ligne séparatrice */}
                  <div className="flex justify-between">
                    <p className="text-gray-600">scheduling appointments</p>
                    <img
                      src="/assets/images/vecteurs/close.svg"
                      alt="icon"
                      className="w-10"
                    />
                  </div>
                </div>

                {/* Card 3 */}
                <div className="p-6 text-center transition-shadow border-4 shadow-lg border-green rounded-xl hover:shadow-xl">
                  <h2 className="text-2xl font-bold text-gray-800">PREMUIM</h2>
                  <div className="my-4 border-t"></div>{" "}
                  {/* Ligne séparatrice */}
                  <div className="flex justify-between">
                    <p className="text-gray-600">Annual subscription</p>
                    <p className="text-gray-800 font-bold">$10</p>
                  </div>
                  <div className="my-4 border-t"></div>{" "}
                  {/* Ligne séparatrice */}
                  <div className="flex justify-between">
                    <p className="text-gray-600">Delivery Services</p>
                    <img
                      src="/assets/images/vecteurs/close.svg"
                      alt="icon"
                      className="w-10"
                    />
                  </div>
                  <div className="my-4 border-t"></div>{" "}
                  {/* Ligne séparatrice */}
                  <div className="flex justify-between">
                    <p className="text-gray-600">Nearby Services</p>
                    <img
                      src="/assets/images/pharmacy/succesIcon.svg"
                      alt="icon"
                      className="w-10"
                    />
                  </div>
                  <div className="my-4 border-t"></div>{" "}
                  {/* Ligne séparatrice */}
                  <div className="flex justify-between">
                    <p className="text-gray-600">Call emergencies</p>
                    <img
                      src="/assets/images/pharmacy/succesIcon.svg"
                      alt="icon"
                      className="w-10"
                    />
                  </div>
                  <div className="my-4 border-t"></div>{" "}
                  {/* Ligne séparatrice */}
                  <div className="flex justify-between">
                    <p className="text-gray-600">Order medications</p>
                    <img
                      src="/assets/images/pharmacy/succesIcon.svg"
                      alt="icon"
                      className="w-10"
                    />
                  </div>
                  <div className="my-4 border-t"></div>{" "}
                  {/* Ligne séparatrice */}
                  <div className="flex justify-between">
                    <p className="text-gray-600">Services fees</p>
                    <img
                      src="/assets/images/pharmacy/succesIcon.svg"
                      alt="icon"
                      className="w-10"
                    />
                  </div>
                  <div className="my-4 border-t"></div>{" "}
                  {/* Ligne séparatrice */}
                  <div className="flex justify-between">
                    <p className="text-gray-600">Record Keeping</p>
                    <img
                      src="/assets/images/pharmacy/succesIcon.svg"
                      alt="icon"
                      className="w-10"
                    />
                  </div>
                  <div className="my-4 border-t"></div>{" "}
                  {/* Ligne séparatrice */}
                  <div className="flex justify-between">
                    <p className="text-gray-600">Data exchange</p>
                    <img
                      src="/assets/images/pharmacy/succesIcon.svg"
                      alt="icon"
                      className="w-10"
                    />
                  </div>
                  <div className="my-4 border-t"></div>{" "}
                  {/* Ligne séparatrice */}
                  <div className="flex justify-between">
                    <p className="text-gray-600">scheduling appointments</p>
                    <img
                      src="/assets/images/pharmacy/succesIcon.svg"
                      alt="icon"
                      className="w-10"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Planstarifs;
